import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ChevronLeft, ChevronRight } from "lucide-react";

// Compacte vorige/volgende-navigatie die de volgorde van het overzicht volgt.
// Toont niets als de huidige rij niet in de opgeslagen lijst zit (bijv. direct geopend).
export function OverzichtNav({ nav, basePad, testid = "overzicht-nav" }) {
  const navigate = useNavigate();
  if (!nav || nav.positie == null) return null;
  return (
    <div className="flex items-center gap-1 border border-border rounded-full px-1 py-0.5 bg-card" data-testid={testid}
         title="Blader met de pijltjestoetsen ↑ / ↓">
      <Button size="icon" variant="ghost" className="h-7 w-7" disabled={!nav.vorige}
        onClick={() => nav.vorige && navigate(`${basePad}/${nav.vorige}`)}
        title="Vorige (↑)" data-testid={`${testid}-vorige`}>
        <ChevronLeft className="h-4 w-4" />
      </Button>
      <span className="text-xs text-muted-foreground tabular-nums px-1 whitespace-nowrap" data-testid={`${testid}-positie`}>
        {nav.positie} / {nav.totaal}
      </span>
      <Button size="icon" variant="ghost" className="h-7 w-7" disabled={!nav.volgende}
        onClick={() => nav.volgende && navigate(`${basePad}/${nav.volgende}`)}
        title="Volgende (↓)" data-testid={`${testid}-volgende`}>
        <ChevronRight className="h-4 w-4" />
      </Button>
    </div>
  );
}
